





































/* eslint-disable no-unused-vars */
// npm
import Vue from 'vue';
import { mapGetters } from 'vuex';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import ElementQueries from 'css-element-queries';
// store/state/models
import KeyListener from '@/KeyListener';
import Mutations from '@/store/mutations';
import UserGroup from '@/models/UserGroup';
import User from '@/models/User';
import Node from '@/models/Node';
import Connection from '@/models/Connection';
import { PacketType } from '@/models/Packet';
import { SendPacket } from '@/networking/SendPacket';
import Tag from '@/models/Tag';
import Vector2 from '@/models/Vector2';
import Vector3 from '@/models/Vector3';
import Camera from '@/models/DOMCamera';
import TimelineAccessUserData from '@/models/TimelineAccessUserData';
import TimelineLayout from './TimelineLayout';
import ColorUtility from '@/util/ColorUtility';
import lerp from '@/util/Lerp';
// views/components
import NodeEditor from './side-panel/NodeEditor.vue';

function daysInMonth (month : number, year : number) 
{
    return new Date(year, month, 0).getDate();
}

function dateTimeToFractionalYear(tgDateTimeObj : Date)
{
    let tgYear = tgDateTimeObj.getUTCFullYear();
    let tgMonth = tgDateTimeObj.getUTCMonth();
    let tgDateDay = tgDateTimeObj.getUTCDate();
    let fracOffset = (tgMonth + tgDateDay / daysInMonth(tgMonth, tgYear)) / 12;
    let hoverDate = tgYear + fracOffset;
    return hoverDate;
}

@Component({
    refs: ['timelineRoot'],
    components: 
	{
	    NodeEditor
	},
    computed:
	{
	    ...mapGetters([
	        'checkTimelineAdmin',
	        'checkTimelineWrite',
	        'checkProjectModerate'
	    ]),
	},
    recomputed: 
	{
	    rootBounds()
	    {
	        if (!this.$refs.timelineRoot)
	        {
	            return {x: 0, y: 0, width: 0, height: 0, top: 0, right: 0, bottom: 0, left: 0};
	        }
	        let size = (this.$refs.timelineRoot as any).getBoundingClientRect();
	        return size;
	    },
	},
    watch: // TODO: use the Watch decorator instead
	{
	    fullscreen()
	    {
	        console.log('Fullscreen modified');
	        setTimeout(() =>
	        {
	            // this.refreshLayout();
	            this.$forceUpdate();
	            this.$recompute('rootBounds');
	        }, 0);
	    },
	},
})
export default class TimelineForm extends Vue
{
	@Prop(Boolean) readonly sidePanelOpen! : Boolean;
	@Prop(Boolean) readonly fullscreen! : Boolean;

	mounted()
	{
	    let startTime = Date.now();
	    KeyListener.init();
	    KeyListener.reset();

	    this.unsubscribeFromMutations = this.$store.subscribe((mutation, state) =>
	    {
	        if (mutation.type == Mutations.updateNodeStart)
	        {
	            this.needsSort = !this.needsSort;
	        }
	    });

	    (this.$refs.timelineRoot as any).scrollTop = 0;

	    this.eraPostprocess();
	}

	beforeDestroy()
	{
	    if (this.unsubscribeFromMutations) this.unsubscribeFromMutations();
	    this.unsubscribeFromMutations = null;
	    this.destroyed = true;
	}

	updated()
	{
	    this.eraPostprocess();
	}

	deltaTime = 0.016;
	unsubscribeFromMutations : any = null;
	resizeSensor : any = null;
	destroyed = false;
	needsSort = false;
	lastEra : Node | null = null;
	extraElements : HTMLElement[] = [];

	get isAnythingSelected()
	{
	    return this.selectedObject != null;
	}

	get selectedObject()
	{
	    return this.$store.state.project.selected;
	}

	get timeline()
	{
	    return this.$store.state.project.activeTimeline;
	}
	
	get nodes()
	{
	    return this.$store.getters.nodes;
	}

	get timelinenodes()
	{
	    let tl = this.timeline;
	    if (tl != null)
	    {
	        var tlnodes = [];
	        for (const nodeid of tl.nodeIDs)
	        {
	            //console.log(nodeid);
	            tlnodes.push(this.nodes.get(nodeid));
	        }
	        return tlnodes;
	    }
	    return null;
	}
	
	get sortedtimelinenodes()
	{
	    let sorted = (this.timelinenodes == null) ? null : (this.timelinenodes.sort((a : Node, b : Node) =>
	    {
	        return a.dateStart.valueOf() - b.dateStart.valueOf();
	    }));
	    return this.needsSort ? sorted : sorted;
	}

	get timelineevents()
	{
	    let tl = this.timeline;
	    if (tl != null)
	    {
	        var tlnodes = [];
	        for (const nodeid of tl.nodeIDs)
	        {
	            //console.log(nodeid);
	            let n = this.nodes.get(nodeid);
	            if (n.isEvent())
	            {
	                tlnodes.push(n);
	            }
	        }
	        return tlnodes;
	    }
	    return null;
	}

	get timelineeras()
	{
	    let tl = this.timeline;
	    if (tl != null)
	    {
	        var tlnodes = [];
	        for (const nodeid of tl.nodeIDs)
	        {
	            //console.log(nodeid);
	            /** @type {Node} */
	            let n = this.nodes.get(nodeid);
	            if (n.isEra())
	            {
	                tlnodes.push(n);
	            }
	        }
	        tlnodes.sort((a,b)=>
	        {
	            // if A is co ntained in B, it should be on top
	            if (a.dateStart >= b.dateStart && a.dateEnd < b.dateEnd)
	            {
	                return 1;
	            }
	            // if B is contained in A, it should be on top
	            else if (b.dateStart >= a.dateStart && b.dateEnd < a.dateEnd)
	            {
	                return -1;
	            }
	            else if (a.dateStart == b.dateStart)
	            {
	                return a.dateEnd - b.dateEnd;
	            }
	            return a.dateStart - b.dateStart;
	        });
	        return tlnodes;
	    }
	    return null;
	}

	get connections()
	{
	    return this.$store.getters.connections;
	}

	get timelineName()
	{
	    return this.timeline != null ? this.timeline.name : '[null]';
	}

	isFiltered(n: Node)
	{
	    if(n.isEra())
	    {
	        return false;
	    }

	    let t = null;
	    for(let tag of n.tags)
	    {
	        if (tag.type == "category")
	        {
	            t = tag;
	        }
	    }

	    if(t == null)
	    {
	        return false;
	    }
	    else
	    {
	        return t.filtered;
	    }
	}

	activeElement()
	{
	    return document.activeElement;
	}

	eraPostprocess()
	{
	    while (this.extraElements.length > 0)
	    {
	        const elem = this.extraElements.pop();
	        if (elem != null)
	        {
	            elem.remove();
	        }
	    }
	    if (this.sortedtimelinenodes != null && this.$refs.editors != null)
	    {
	        const editors : HTMLElement[] = this.$refs.editors as HTMLElement[];
	        let lastEra : Node | null = null;
	        for (let i = 0; i < this.sortedtimelinenodes.length; ++i)
	        {
	            const n : Node = this.sortedtimelinenodes[i];
	            if (lastEra != null && n.dateStart.valueOf() >= lastEra.dateEnd.valueOf())
	            {
	                if (editors[i] != null)
	                {
	                    const parent = editors[i].parentElement;
	                    if (parent != null)
	                    {
	                        const elem = document.createElement('div');
	                        elem.style.cssText = `padding: 6px 10px; width: 100%; background-color: ${lastEra.eraBackgroundColorString};`;
	                        elem.innerHTML = `<span style="font-size: 100%; font-weight: bolder;" aria-label="end of era ${lastEra.name}">End of Era: ${lastEra.name}</span>`;
	                        parent.insertBefore(elem, editors[i]);
	                        this.extraElements.push(elem);
	                    }
	                }
	                lastEra = null;
	            }
	            if (n.isEra())
	            {
	                lastEra = n;
	            }
	            if (editors[i] != null)
	            {
	                editors[i].style.cssText = (lastEra != null) ? `background-color: ${lastEra.eraBackgroundColorString};` : '';
	            }
	        }
	        if (lastEra != null)
	        {
	            if (editors.length > 0 && editors[editors.length - 1] != null)
	            {
	                const parent = editors[editors.length - 1].parentElement;
	                if (parent != null)
	                {
	                    const elem = document.createElement('div');
	                    elem.style.cssText = `padding: 6px 10px; width: 100%; background-color: ${lastEra.eraBackgroundColorString};`;
	                    elem.innerHTML = `<span style="font-size: 100%; font-weight: bolder;" aria-label="end of era ${lastEra.name}">End of Era: ${lastEra.name}</span>`;
	                    parent.insertAdjacentElement('beforeend', elem);
	                    this.extraElements.push(elem);
	                }
	            }
	            lastEra = null;
	        }
	    }
	}
}
